/**
 * Build default answers from the API response sections.
 * apiSections = [ { section, questions: [{ id, question, description, subDimension }] } ]
 */
export const buildDefaultAnswers = (apiSections) => {
  return Object.fromEntries(
    apiSections.map((sec) => [
      sec.section,
      sec.questions.map(() => ({ response: null, comment: "" })),
    ])
  );
};

/**
 * Completion % = answered questions (yes/no/partial) out of total non-Report questions.
 */
export const computeCompletion = (apiSections, answers) => {
  let total = 0, answered = 0;
  apiSections
    .filter((sec) => sec.section !== "Report")
    .forEach((sec) => {
      (answers[sec.section] || []).forEach((a) => {
        total++;
        if (a.response !== null) answered++;
      });
    });
  return total === 0 ? 0 : Math.round((answered / total) * 100);
};

/**
 * Report unlocks when every non-Report question has ANY answer.
 */
export const isAllSectionsAnswered = (apiSections, answers) => {
  return apiSections
    .filter((sec) => sec.section !== "Report")
    .every((sec) =>
      (answers[sec.section] || []).every((a) => a.response !== null)
    );
};

export const progressColor = (pct) =>
  pct >= 70 ? "#22c55e" : pct >= 40 ? "#f59e0b" : "#ef4444";